/**
 * KAN-826: read-only list of fields from list imports, shared by the company
 * card ("Дополнительно") and the client card ("Данные из базы").
 *
 * A small "боту" mark is shown for fields passed to the bot.
 */
import type { ExtraFieldItem } from '@/lib/extraFields';

export function ExtraFieldsList({ items }: { items: ExtraFieldItem[] }): JSX.Element {
  return (
    <dl className="grid grid-cols-1 gap-x-4 gap-y-2 text-sm sm:grid-cols-[minmax(0,1fr)_minmax(0,2fr)]">
      {items.map((item) => (
        <div key={item.name} data-testid="extra-field" className="contents">
          <dt className="text-gray-500">{item.name}</dt>
          <dd className="break-words text-gray-900">
            {item.value}
            {item.toBot && (
              <span
                data-testid="extra-to-bot"
                title="Передаётся боту"
                className="ml-2 rounded bg-blue-50 px-1.5 py-0.5 align-middle text-[11px] font-medium text-blue-700"
              >
                боту
              </span>
            )}
          </dd>
        </div>
      ))}
    </dl>
  );
}
